import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';

@Component({
    selector: 'page-article-view-price',
    templateUrl: 'article-view-price.html',
})
export class ArticleViewPricePage {
    @Input() article: any;
    @Input() article_pvp: any;
    @Input() article_pvp2: any;
    @Input() article_pvp3: any;
    @Input() article_pvp_tk: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals) {

    }

    profitFoodCost(price) {
        var foodcost = 0;
        var price_notax = 0;
        if (this.article.type === 'dish') {
            foodcost = (this.article.foodcost_static / this.article.foodcost_parts) * 1;
            price_notax = this.globals.createSubTotal(price, this.globals.RESTAURANT_TAX);
        } else {
            if (this.article.sub_recipe) {
                foodcost = (this.article.price_static / this.article.foodcost_parts) * 1;
                price_notax = this.globals.createSubTotal(price, this.globals.RESTAURANT_TAX);
            } else {
                foodcost = (this.article.price_static / 1) * 1;
                price_notax = this.globals.createSubTotal(price, this.globals.RESTAURANT_TAX);
            }
        }
        return this.globals.ifVarisFiniteOrNaN(100 - this.globals.regla3(price_notax, foodcost));
    }
}



// WEBPACK FOOTER //
// ./src/pages/articles/articles-view/article-view-price/article-view-price.ts